import React from 'react'
import ELearningRegistrationDetail from 'src/modules/MyClass/ELearningRegistrationDetail'

const ELearningRegistrationDetailPage = () => {
  return <ELearningRegistrationDetail />
}

export default ELearningRegistrationDetailPage
